import ajaxService from './ajaxService';

export default {
  // 取得會員資料
  getCustomerData(body, headers) {
    return ajaxService.post('/mbc/post/api/v1/customerdataquery', body, headers);
  },
  // 取得會籍資料
  getMemberType(body, headers) {
    return ajaxService.post('/mbc/post/api/v1/member-type-query', body, headers);
  },
  // 取得會員帳號資訊
  getMemberAccount(param, headers) {
    const queryString = new URLSearchParams(param).toString();
    return ajaxService.post(`/mbc/get/api/v1/member-account?${queryString}`, {}, headers);
  },
  // 會員貼標
  PostMemberTag(body) {
    return ajaxService.post('/mbc/post/api/v1/member-tag', body);
  },
  // 驗證帳號存在
  getAccountVerifier(param) {
    const queryString = new URLSearchParams(param).toString();
    return ajaxService.post(`/mbc/get/api/v1/account-verifier?${queryString}`);
  },
  postCustomerdataadd(body, headers) {
    return ajaxService.post('/mbc/post/api/v1/customerdataadd', body, headers);
  },
  // 新增會員個人通知
  async postMemberNotice(body) {
    try {
      const res = await ajaxService.post('/mbc/post/api/v1/member/notice', body);
      return res.toPromise();
    } catch (err) {
      return err.response;
    }
  },
  // 取得標籤
  async getCustomerTag(param) {
    try {
      const queryString = new URLSearchParams(param).toString();
      const res = await ajaxService.post(`/mbc/get/api/v1/customer/tags?${queryString}`);
      return res.toPromise();
    } catch (err) {
      return err.response;
    }
  },
  // 新增Account
  postCustomerDataBind(body, headers) {
    try {
      const res = ajaxService.post('/mbc/post/api/v1/customerdatabind', body, headers);
      return res;
    } catch (err) {
      return err.response;
    }
  },
  // 判斷是會員還是潛客
  async PostProspectiveCustomer(body) {
    try {
      const res = await ajaxService.post('/mbc/post/api/v1/member/prospectiveCustomer', body);
      return res.toPromise();
    } catch (err) {
      return err.response;
    }
  },
};
